import React from "react";
import ReferredTable from "./ReferredTable";

const Referred = () => {
  return (
    <div className=" flex flex-col gap-6 md:p-8 p-4 bg-gray-100 min-h-screen">
      <div className="flex items-center justify-between">
        <h1 className=" text-lg md:text-2xl font-bold">Referred Users</h1>
      </div>
      <ReferredTable />
    </div>
  );
};

export default Referred
